import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/static/icons/confirmation.svg'


const _hoisted_1 = {
  key: 1,
  class: "installer__header-separator-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("line", { class: "installer__header-separator" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 3,
  class: "installer__organization-status"
}
const _hoisted_5 = { class: "installer__organization-status-logo" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "confirmation-icon"
}, null, -1)
const _hoisted_7 = ["innerHTML"]

import { ref } from 'vue';

import useUser from '@/composables/useUser';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

import MyPagesBack from '@/components/MyPages/components/MyPagesBack.vue';
import InstallerHeading from './InstallerHeading.vue';
import InstallerForm from './InstallerForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Installer',
  emits: ['close-modal', 'back'],
  setup(__props, { emit }) {

const { user } = useUser();
const { websiteText } = useWebsiteTexts();



const isInstallerFormVisible = ref(true);
const confirmationMessage = ref('');

function onAddInstallerSuccedded() {
  confirmationMessage.value = websiteText('mypages__add_installer', {
    organization: `<strong> ${
      user.value?.organization?.organizationName || ''
    } </strong>`,
  }).value;
  isInstallerFormVisible.value = false;
}

function onEditInstallerSuccedded() {
  confirmationMessage.value = websiteText('mypages__edit_installer', {
    organization: `<strong> ${
      user.value?.organization?.organizationName || ''
    } </strong>`,
  }).value;
  isInstallerFormVisible.value = false;
}

function onShowFormClicked() {
  isInstallerFormVisible.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MyPagesBack, {
      onBack: _cache[0] || (_cache[0] = ($event: any) => (emit('back'))),
      onExit: _cache[1] || (_cache[1] = ($event: any) => (emit('close-modal')))
    }),
    (isInstallerFormVisible.value)
      ? (_openBlock(), _createBlock(InstallerHeading, { key: 0 }))
      : _createCommentVNode("", true),
    (isInstallerFormVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (isInstallerFormVisible.value)
      ? (_openBlock(), _createBlock(InstallerForm, {
          key: 2,
          onAdd: onAddInstallerSuccedded,
          onEdit: onEditInstallerSuccedded,
          onRemove: _cache[2] || (_cache[2] = ($event: any) => (emit('back')))
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", {
              class: "text",
              innerHTML: confirmationMessage.value
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("button", {
            class: "secondary-button secondary-button--inverted",
            onClick: onShowFormClicked
          }, _toDisplayString(_unref(websiteText)('mypages__installer_see_info').value), 1)
        ]))
  ], 64))
}
}

})